import { useState, useEffect, } from "react";
import Box from '@mui/material/Box';
import { getEndpoint, getMUICache, getUrl, getImageUrl, handleSearchClick, getLoggedUserName,getLoggedUserEmail, logoutUser, getLoggedInFlag, fetchAnchorValue, safeCharAt } from "../../common/utils";
import Grid from '@mui/material/Grid';
import { CacheProvider } from '@emotion/react';
import AppBar from '@mui/material/AppBar';
import Toolbar from '@mui/material/Toolbar';
// import IconButton from '@mui/material/IconButton';
// import MenuIcon from '@mui/icons-material/Menu';
import InputAdornment from '@mui/material/InputAdornment';
import TextField from '@mui/material/TextField';
import SearchIcon from '@mui/icons-material/Search';
import { Link } from '@mui/material';
import MainMenu from '../MainMenu/MainMenu';
import DrawerComponent from "../Sidebar/DrawerComponent";
import bcrypt from 'bcryptjs-react';
import './header.css';
import { PAGEBUILDER_URLS } from '../Common/Constant';

Header.version = 1000;

Header.lang = 'en';
Header.langs = [
  'en'
];
Header.setLang = (lang: any) => {
  Header.lang = lang;
}

Object.defineProperty(Header, 'name', {
  writable: true,
  value: 'Header'
});

// Define a type for the fetch options
interface FetchOptions {
  method: string;
  headers: {
    'Content-Type': string;
    'p-nonce': string;
  };
  credentials?: RequestCredentials; // Use RequestCredentials type
}

export function Header(props: any) {

  const [menuItems, setMenuItems] = useState<any>([]);
  const [headerData, setHeaderData] = useState<any>({});
  const [showMainMenu, setMainMenu] = useState(false);
  const [loggedUserName, setLoggedUserName] = useState<any>("");
  const [loggedUserEmail, setLoggedUserEmail] = useState<any>("");
  const [loginLink, setLoginLink] = useState<any>();
  const [toogleMenuData, setToggleMenuData] = useState<any>([]);
  const [searchValue, setSearchValue] = useState<any>("");
  const [loginEnabled, setLoginEnabled] = useState(false);

  // const endpointHostId = getEndpoint(props, "HEADER_MENU_API");
  // const hostId = endpointHostId.queryParams.hostId;

  // console.log("header hostId :  " , hostId);

  const {
    onClick,
    showSearch,
    isSticky,
    CONSTANTS,
    noOfHeaderItems,
    anchorLinksValue
    /*MSID*/
  } = props;

  if( !loginEnabled && props && props.transportData && props.transportData.isLoginEnabled ) {
    setLoginEnabled(props.transportData.isLoginEnabled);
  }

  const endpoint = getEndpoint(props, "MAIN");
  const headerMenuEndpoint = getEndpoint(props, "HEADER_MENU_API");
  const togglerEndpoint = getEndpoint(props, "TOGGLER_MENU_API");

  const hostId = headerMenuEndpoint?.queryParams?.hostId;

  // const hostId = headerMenuEndpoint.queryParams != null ? headerMenuEndpoint.queryParams.hostId : togglerEndpoint.queryParams.hostId;

  useEffect(() => {
    if (!endpoint.isSSR || !endpoint.SSRDataObj || !headerMenuEndpoint.isSSR || !headerMenuEndpoint.SSRDataObj) {
      fetchComponentData();
    }
    if( !loginEnabled && props && props.transportData && props.transportData.isLoginEnabled ) {
      setLoginEnabled(props.transportData.isLoginEnabled);
    }
    setLoginEnabled(getLoggedInFlag());
  }, []);

  if (endpoint.isSSR && endpoint.SSRDataObj && (!headerData || !Object.keys(headerData).length)) {
    setHeaderData(endpoint.SSRDataObj);

    if (isSticky) {
      setTimeout(() => {
        if (typeof document !== 'undefined' && undefined !== document && document && document.getElementsByTagName("header") && document.getElementsByTagName("header")[0])
          document.getElementsByTagName("header")[0].classList.add("sticky");
      })
    }
  }

  if (headerMenuEndpoint.isSSR && headerMenuEndpoint.SSRDataObj && headerMenuEndpoint.SSRDataObj.length && (!menuItems || !menuItems.length)) {
    setMenuItems(headerMenuEndpoint.SSRDataObj);
  }

  if (togglerEndpoint.isSSR && togglerEndpoint.SSRDataObj && togglerEndpoint.SSRDataObj.length && (!toogleMenuData || !toogleMenuData.length)) {
    setToggleMenuData(togglerEndpoint.SSRDataObj);
  }

  const toggleMainMenu = () => {
    if (toogleMenuData.length == 0) {
      getToggleMenuData();
    } else {
      setMainMenu(!showMainMenu);
    }
  }

  const getToggleMenuData = () => {
    let toggleMenuAPIurl = getUrl(props, 0, false, "TOGGLER_MENU_API", true)

    let headerString = '?' + toggleMenuAPIurl.split("?")[1];
    headerString = bcrypt.hashSync(headerString, 6);
    const headers = { 'p-nonce': headerString };

    fetch(toggleMenuAPIurl, { headers: headers }).then((response) => response.json())
      .then((val) => setToggleMenuData(val))
      .then(() => setMainMenu(true))
  }

  const fetchComponentData = () => {
    const { ENDPOINTS } = props;
    let headerAPI = getUrl(props, 0, false, "MAIN", true, ENDPOINTS[0].queryParams.websiteId, ENDPOINTS[0].queryParams.clientId)
    let menuAPIurl = getUrl(props, 0, false, "HEADER_MENU_API", true)
    // let document = typeof document !== 'undefined' && undefined !== document && document;

    let headerString = `?` + headerAPI.split("?")[1];
    headerString = bcrypt.hashSync(headerString, 6);
    const customHeaders = {
      'Content-Type': 'application/json',
      'p-nonce': headerString
    };
    var fetchOptions: FetchOptions = {
      method: 'GET',
      headers: customHeaders
    };

    let headerString_menuAPIurl = '?' + menuAPIurl.split("?")[1];
    headerString_menuAPIurl = bcrypt.hashSync(headerString_menuAPIurl, 6);
    const headers_menuAPIurl = { 'p-nonce': headerString_menuAPIurl };

    if (headerAPI.includes('getsiteResources') && !headerAPI.includes("rendering/getsiteResources") &&
      (typeof document !== 'undefined' && undefined !== document && document
        && !PAGEBUILDER_URLS.some(domain => window.location.origin.includes(domain)))) {
      headerAPI = headerAPI.replace("getsiteResources", "rendering/getsiteResources");
    } else { fetchOptions.credentials = "include"; }
    Promise.all([
      fetch(headerAPI, fetchOptions).then((response) => response.json()),
      fetch(menuAPIurl, { headers: headers_menuAPIurl }).then((response) => response.json()),
    ])
      .then(([result1, result2]) => {
        // Handle the results individually
        setHeaderData(result1);
        setMenuItems(result2);
      })
      .catch((error) => {
        // Handle errors here
        console.error('Error fetching data:', error);
      });
  }

  const handleKeyPress = (event: any) => {
    if (event.key === 'Enter') {
      event.preventDefault(); // Prevent form submission or new window/popup
      handleSearchClick(searchValue, hostId); // Call your search handling function
    }
  }


  const [scroll, setScroll] = useState(false);
  useEffect(() => {
    setLoggedUserName(getLoggedUserName());
    setLoggedUserEmail(getLoggedUserEmail());
    setLoginLink( "/login?url=" + encodeURIComponent(window.location.href) );
    window.addEventListener("scroll", () => {
      setScroll(window.scrollY > 20);
    });
  }, []);

  const rendertopBar = () => {
    return <AppBar position="relative" color='default' className={scroll ? "bg-black" : "bg-white"}>
      <Toolbar className='header-top'>
        <div className="header-left">
          {/* <div className="sidebar-menu-icon" onClick={toggleMainMenu}>
            <IconButton size="large" edge="start" color="inherit" aria-label="open drawer" sx={{ mr: 2 }}>
              <MenuIcon />
            </IconButton>
          </div> */}
          <div id="HeaderlogoIn" className="">
            <Link href="/" aria-label="logo" target={fetchAnchorValue(anchorLinksValue, "/")} className="main-logo">
              {/* <img src={getImageUrl(MSID, 332223, "thumbnailImage")} alt='' /> */}
              {headerData && headerData.mainLogo && <img src={getImageUrl(headerData.mainLogo, "422424", 96, undefined, "", false, props.CONSTANTS)} alt="logo" width="96" height="36" />}
            </Link>
          </div>
        </div>
        {showSearch && <div className="search-main">
          <div className="search">
            {/* <form id="search_sbmt" onSubmit={handleFormSubmit}>
              <TextField id="" placeholder='Search' type='text' onKeyPress={(e) => handleKeyPress(e)} onChange={e => setSearchValue(e.target.value)}
                InputProps={{
                  endAdornment: <InputAdornment position="end" ><SearchIcon onClick={() => handleSearchClick(searchValue)} /></InputAdornment>
                }}
              />
            </form> */}
            <TextField
              id=""
              placeholder='Search'
              type='text'
              onKeyPress={(e) => handleKeyPress(e)}
              onChange={e => setSearchValue(e.target.value)}
              InputProps={{
                endAdornment: (
                  <InputAdornment position="end">
                    <SearchIcon onClick={() => handleSearchClick(searchValue, hostId)} />
                  </InputAdornment>
                )
              }}
            />
          </div>
         
        </div>
        
        }
          <div className="ThemeOneMainLoginFunctionWrap">
          {getLoginString()}
        </div>
      </Toolbar>
    </AppBar>
  }
  let defaultDomainUrl: any = "";
  if (typeof window !== 'undefined' && undefined !== window && window) {
    defaultDomainUrl = "https://" + window.location.hostname;
  } else {
    defaultDomainUrl = (props && props.REQUEST_HOSTNAME) && "https://" + props.REQUEST_HOSTNAME;
  }

  const getLoginString = () => {
    if( loginEnabled ) {
      if( loggedUserName ) {
        return <div className="ThemeThreeWelcomeWrapper">
          <button className="ThemeOneAfterLoginButton">{safeCharAt(loggedUserName)}</button>
          <ul className="ThemeOneListLog">
          <li className="ThemeOneDesktopUserName">{loggedUserName} <span  className="ThemeOneDesktopUserEmail">{loggedUserEmail}</span></li>
            <li> <a onClick={logoutUser} href="javascript:void(0)">Logout</a></li>
          </ul>
          </div>
      }
      return <div className="ThemeOneLoginWrapper">
        <a href={loginLink} className="ThemeOneLoginAnchor"><svg width="26" height="26" viewBox="0 0 26 26" fill="none" xmlns="http://www.w3.org/2000/svg">
  <path d="M20.182 17.7313L20.1766 17.7259L20.1711 17.7207L20.014 17.573L20.0085 17.5678L20.0028 17.5627C19.2675 16.9121 18.3175 16.55 17.33 16.55H8.66336H8.65574L8.64812 16.5502L8.43264 16.5568L8.42502 16.557L8.41741 16.5575C7.43743 16.6173 6.50959 17.0331 5.81137 17.7313C5.05497 18.4877 4.63003 19.5136 4.63003 20.5833V22.7345L4.62596 22.8C4.60245 22.9417 4.47853 23.05 4.33003 23.05C4.16434 23.05 4.03003 22.9157 4.03003 22.75V20.5895L4.03603 20.3475C4.09422 19.2046 4.57392 18.1202 5.3871 17.3071L5.3871 17.3071C6.25601 16.4381 7.43453 15.95 8.66336 15.95H17.33C18.5588 15.95 19.7373 16.4381 20.6063 17.3071C21.4752 18.176 21.9633 19.3545 21.9633 20.5833V22.7345L21.9593 22.8C21.9358 22.9417 21.8119 23.05 21.6633 23.05C21.4977 23.05 21.3633 22.9157 21.3633 22.75V20.5833C21.3633 19.5136 20.9385 18.4877 20.182 17.7313Z" fill="#666666" stroke="#666666"/>
  <path d="M13.2107 11.6113L13.2107 11.6114L13.2242 11.6107C15.3493 11.4958 17.0367 9.73679 17.0367 7.58333H17.0368L17.0365 7.56985L17.0313 7.37598L17.0314 7.37598L17.0307 7.36247C16.9158 5.23741 15.1568 3.55 13.0033 3.55V3.54982L12.9898 3.55018L12.796 3.55541L12.796 3.55522L12.7825 3.55595C10.6574 3.67086 8.97 5.42987 8.97 7.58333H8.96981L8.97018 7.59681L8.9754 7.79067L8.97522 7.79068L8.97595 7.80419C9.09086 9.92926 10.8499 11.6167 13.0033 11.6167V11.6168L13.0168 11.6165L13.2107 11.6113ZM12.802 12.2124C10.3384 12.1073 8.37266 10.0776 8.37 7.58838L8.37428 7.38204C8.4794 4.91837 10.5091 2.95266 12.9983 2.95L13.2046 2.95428C15.6683 3.0594 17.634 5.08911 17.6367 7.57828L17.6324 7.78462C17.5273 10.2483 15.4976 12.214 13.0084 12.2167L12.802 12.2124Z" fill="#666666" stroke="#666666"/>
  </svg>
  </a>
        </div>
    }
  }

  return (
    <div className="card_wrapper" onClick={onClick}>
      <CacheProvider value={getMUICache()}>
        <Box sx={{ flexGrow: 1 }} className="header">
          <Grid spacing={2} container direction="column">
            <Grid item md={12} className="ThemeOneRendertopBar">
              {rendertopBar()}
            </Grid>
            <Grid item md={12} className='menu-wrap'>
              {headerData && Object.keys(headerData).length && 
              <MainMenu 
                menuItems={menuItems} 
                domainUrl={defaultDomainUrl} 
                toggleMainMenu={toggleMainMenu} 
                headerMenuEndpoint={headerMenuEndpoint} 
                cdsDomain={CONSTANTS.CDS_API} 
                noOfHeaderItems = {noOfHeaderItems}
                anchorLinksValue = {anchorLinksValue}
              />}
            </Grid>
          </Grid>

          {showMainMenu &&
            <Grid item md={12} className='menu-wrap'>
              <DrawerComponent toggleMainMenu={toggleMainMenu} menuItems={toogleMenuData} domainUrl={defaultDomainUrl} props={props} hostId={hostId} anchorLinksValue = {anchorLinksValue}/>
            </Grid>
          }
        </Box>
      </CacheProvider>
    </div>
  );
}